import { isEmail, isEmpty } from "validator"
import moment from "moment"

export default values => {
  const errors = {}
  if (!values.email) {
    errors.email = "Cannot be blank"
  } else if (!isEmail(values.email)) {
    errors.email = "Invalid email address"
  }
  if (!values.friendlyName || isEmpty(values.friendlyName)) {
    errors.friendlyName = "Cannot be blank"
  }
  if (!values.language || isEmpty(values.language)) {
    errors.language = "Cannot be blank"
  }
  if (!values.primarySensor || !values.primarySensor.id) {
    errors.primarySensor = { id: "Cannot be blank" }
  }
  if (!values.startsAt) {
    errors.startsAt = "Cannot be blank"
  }
  if (!values.endsAt) {
    errors.endsAt = "Cannot be blank"
  }
  if (!values.latitude) {
    errors.latitude = "Cannot be blank"
  }
  if (!values.longitude) {
    errors.longitude = "Cannot be blank"
  }
  if (
    values.startsAt &&
    values.endsAt &&
    moment(values.startsAt).isAfter(values.endsAt)
  ) {
    errors.startsAt = "Must occur before the expiration date."
  }
  return errors
}



// WEBPACK FOOTER //
// ./src/Kiosks/validate.js